/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	AcademicUser,
	AcademicUserFromJSON,
	AcademicUserFromJSONTyped,
	AcademicUserToJSON,
} from "./AcademicUser";
import {
	Company,
	CompanyFromJSON,
	CompanyFromJSONTyped,
	CompanyToJSON,
} from "./Company";

/**
 *
 * @export
 * @interface StudentCVAccess
 */
export interface StudentCVAccess {
	/**
	 *
	 * @type {string}
	 * @memberof StudentCVAccess
	 */
	id?: string;
	/**
	 *
	 * @type {Date}
	 * @memberof StudentCVAccess
	 */
	createdAt?: Date;
	/**
	 *
	 * @type {Date}
	 * @memberof StudentCVAccess
	 */
	updatedAt?: Date;
	/**
	 *
	 * @type {string}
	 * @memberof StudentCVAccess
	 */
	studentId?: string;
	/**
	 *
	 * @type {string}
	 * @memberof StudentCVAccess
	 */
	companyId?: string;
	/**
	 *
	 * @type {boolean}
	 * @memberof StudentCVAccess
	 */
	downloaded?: boolean;
	/**
	 *
	 * @type {AcademicUser}
	 * @memberof StudentCVAccess
	 */
	student?: AcademicUser;
	/**
	 *
	 * @type {Company}
	 * @memberof StudentCVAccess
	 */
	company?: Company;
}

export function StudentCVAccessFromJSON(json: any): StudentCVAccess {
	return StudentCVAccessFromJSONTyped(json, false);
}

export function StudentCVAccessFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): StudentCVAccess {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		id: !exists(json, "id") ? undefined : json["id"],
		createdAt: !exists(json, "createdAt")
			? undefined
			: new Date(json["createdAt"]),
		updatedAt: !exists(json, "updatedAt")
			? undefined
			: new Date(json["updatedAt"]),
		studentId: !exists(json, "studentId") ? undefined : json["studentId"],
		companyId: !exists(json, "companyId") ? undefined : json["companyId"],
		downloaded: !exists(json, "downloaded") ? undefined : json["downloaded"],
		student: !exists(json, "student")
			? undefined
			: AcademicUserFromJSON(json["student"]),
		company: !exists(json, "company")
			? undefined
			: CompanyFromJSON(json["company"]),
	};
}

export function StudentCVAccessToJSON(value?: StudentCVAccess | null): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		id: value.id,
		createdAt:
			value.createdAt === undefined ? undefined : value.createdAt.toISOString(),
		updatedAt:
			value.updatedAt === undefined ? undefined : value.updatedAt.toISOString(),
		studentId: value.studentId,
		companyId: value.companyId,
		downloaded: value.downloaded,
		student: AcademicUserToJSON(value.student),
		company: CompanyToJSON(value.company),
	};
}
